import ComparisonCard from "./ComparisonCard";

export default ComparisonCard;
